module.exports = __webpack_public_path__ + "img/red-cross.eea659c7.svg";